export default __webpack_public_path__ + "static/media/Expert icon 20px.2f9acdf6.svg";